import { formatCurrency } from 'utils/formatCurrency';

import { CarrierCostType, ProfitType } from '../types';

type BuildSellRateFormulaArgs = {
  carrierCost: number;
  profit: number;
  profitType: ProfitType;
  carrierCostType: CarrierCostType;
  isMarginEnabled: boolean;
  formatAmount?: (amount: number, maxFractionDigits?: number) => string;
};

function formatBuyOrProfit(
  value: number,
  carrierCostType: CarrierCostType,
  formatAmount?: (amount: number, maxFractionDigits?: number) => string
): string {
  if (formatAmount) {
    if (carrierCostType === CarrierCostType.PerMile) {
      return formatAmount(value, 2);
    }

    return formatAmount(value);
  }

  if (carrierCostType === CarrierCostType.PerMile) {
    return formatCurrency(value, 'USD', 2);
  }
  return formatCurrency(value, 'USD');
}

function formatPercent(value: number): string {
  const formatted = value.toFixed(2).replace(/\.?0+$/, '');
  return formatted;
}

// Builds a compact sell-rate formula for the sticky footer, e.g.
// `$5,523 + 10% margin` or `$5,523 + $552 markup`.
export function buildSellRateFormula({
  carrierCost,
  profit,
  profitType,
  carrierCostType,
  isMarginEnabled,
  formatAmount,
}: BuildSellRateFormulaArgs): string {
  const buyLabel = formatBuyOrProfit(
    carrierCost,
    carrierCostType,
    formatAmount
  );
  const profitNoun = isMarginEnabled ? 'margin' : 'markup';

  if (profitType === ProfitType.Amount) {
    const profitLabel = formatBuyOrProfit(
      profit,
      carrierCostType,
      formatAmount
    );
    return `${buyLabel} + ${profitLabel}`;
  }

  return `${buyLabel} + ${formatPercent(profit)}% ${profitNoun}`;
}

export function formatStickySellRate(
  finalPrice: number,
  carrierCostType: CarrierCostType,
  formatAmount?: (amount: number, maxFractionDigits?: number) => string
): string {
  if (formatAmount) {
    if (carrierCostType === CarrierCostType.PerMile) {
      return `${formatAmount(finalPrice, 2)}/mi`;
    }

    return formatAmount(finalPrice);
  }

  if (carrierCostType === CarrierCostType.PerMile) {
    return `${formatCurrency(finalPrice, 'USD', 2)}/mi`;
  }
  return formatCurrency(finalPrice, 'USD');
}
